import { OgpCompanyType } from '@types';
import { ResolveNavigatedOgpCompanyTypeInput } from './resolve-navigated-ogp-company-type.types';

export const resolveNavigatedOgpCompanyType = ({
  navigatedCompanyHash,
  userCompanySlug,
  userCompanyType,
  navigatedCompanyType,
  isNavigatedCompanyDetailSettled,
}: ResolveNavigatedOgpCompanyTypeInput): OgpCompanyType => {
  if (isNavigatedCompanyDetailSettled) {
    return navigatedCompanyType ?? 'FULL';
  }

  if (navigatedCompanyHash && userCompanySlug === navigatedCompanyHash) {
    return userCompanyType ?? 'FULL';
  }

  return userCompanyType ?? 'FULL';
};
